import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  IconButton,
  Typography,
  Box,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

interface ShortlistConfigDialogProps {
  open: boolean;
  onClose: () => void;
  onSubmit: () => void;
  sliderValue: number;
  onSliderChange: (value: number) => void;
}

const ShortlistConfigDialog: React.FC<ShortlistConfigDialogProps> = ({
  open,
  onClose,
  onSubmit,
  sliderValue,
  onSliderChange,
}) => {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
      <DialogTitle sx={{ fontWeight: 600, fontSize: '16px', pb: 1, color: '#101828' }}>
        Configure shortlisting Benchmark
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{ position: 'absolute', right: 8, top: 8 }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent sx={{ pb: 1 }}>
        <Typography sx={{ fontSize: '14px', color: '#475467', mb: 2 }}>
          The system will only shortlist the candidate if they match or exceed the
          benchmark.
        </Typography>
        <Box display="flex" alignItems="center" gap={2}>
          <input
            type="range"
            min={0}
            max={100}
            value={sliderValue}
            onChange={(e) => onSliderChange(Number(e.target.value))}
            style={{ width: '100%', accentColor: '#5175e0' }}
          />
          <Typography sx={{ width: '40px', fontWeight: 500 }}>
            {sliderValue}%
          </Typography>
        </Box>
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 2 }}>
        <Button
          onClick={onClose}
          sx={{
            background: '#FAFAFA',
            border: '1px solid #D1D5DB',
            color: '#111827',
          }}
        >
          Cancel
        </Button>
        <Button
          variant="contained"
          onClick={onSubmit}
          sx={{ border: '1px solid #111827', background: '#325CD6' }}
        >
          Submit
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ShortlistConfigDialog; 